var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DashboardPage"},[_c('DashboardWelcome',{staticClass:"DashboardPage__welcome"}),_c('DashboardBody',{staticClass:"DashboardPage__tabs"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }